import { FileResponse } from '@/helpers/hubspot/types';
import logError from '@/helpers/logError';
import { Dispatch } from 'react';
import { v4 } from 'uuid';
import { RepairFormState } from '../../../../../constants';
import { PictureStepActions } from '../../../state';
import { getHubspotFileFolder } from './getHubspotFileFolder';
import { RepairFormActionMap } from '../../../../../reducer';

export const uploadImage = (
	state: RepairFormState,
	dispatch: Dispatch<RepairFormActionMap>,
	images: File[],
) => {
	// If there are no images, then there is nothing to do.
	if (images.length < 1) {
		return;
	}

	const uploadBatchId = v4();

	dispatch({
		type: PictureStepActions.START_IMAGE_UPLOAD,
		payload: images.map((image) => ({ file: image, uploadBatchId })),
	});

	const addImagesToHubspot = async (files: File[]) => {
		const formData = new FormData();
		files.forEach((file) => {
			formData.append('files', file);
		});

		const hubspotFolderId = await getHubspotFileFolder(state, dispatch);
		if (hubspotFolderId) {
			formData.append('folderId', hubspotFolderId);
		}

		try {
			const response = await fetch(`/api/hubspot/file/`, {
				method: 'POST',
				body: formData,
			});

			if (!response.ok) {
				throw new Error('Failed to upload files to HubSpot');
			}

			const data = (await response.json()) as FileResponse;
			// Return the data
			return { files: data.files, uploadBatchId };
		} catch (error) {
			logError(error as Error);

			// Return an empty array in case of error
			return { files: [], uploadBatchId };
		}
	};

	addImagesToHubspot(images)
		.then((hubspotResult) => {
			dispatch({
				type: PictureStepActions.END_HUBSPOT_FILE_UPLOAD,
				payload: hubspotResult,
			});
		})
		.catch((error) => {
			console.log('Error uploading images', error);
			logError(error as Error);
		});
};
